// Copyright © 2025 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import axios from 'axios';
import { getConfig } from '../../reducers/portalConfig';
import * as CONSTANTS from '../../constants';
import { get } from "lodash";

const GOOGLE_ANALYTICS_ID = "GOOGLE_ANALYTICS_ID";

export const fetchTenantInfos = () => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  dispatch({ type: CONSTANTS.TENANT_INFO_REQUEST });
  let tenantInfoResponse, settingsResponse;
  const payload = {};

  try {
    tenantInfoResponse = await axios.get(`${portal.hostname}/api/${portal.tenantPrefix}/api-management/internal/tenant_info`);
    if (tenantInfoResponse && tenantInfoResponse.data) {
      payload['adminEmail'] = get(tenantInfoResponse.data, "adminEmail")
    }
  } catch (error) {
    handleError(error, CONSTANTS.TENANT_INFO_ERROR, dispatch);
    return;
  }
  try {
    settingsResponse = await axios.get(`${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/${GOOGLE_ANALYTICS_ID}`);
    if (settingsResponse && settingsResponse.data) {
      payload['trackingId'] = get(settingsResponse.data, "value")
    }
  } catch (error) { payload['trackingId'] = ""; }
  dispatch({ type: CONSTANTS.TENANT_INFO_SUCCESS, payload })
}

export const updateTenantInfos = (payload) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  dispatch({ type: CONSTANTS.UPDATE_TENANT_INFO_REQUEST })
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/internal/tenant_info`;

  await axios.patch(url, payload)
  .then((response) => {
      if (response.status === 204) {
        dispatch({ type: CONSTANTS.UPDATE_TENANT_INFO_SUCCESS, payload : true });
      }
    })
    .catch((error) => {
      handleError(error, CONSTANTS.UPDATE_TENANT_INFO_ERROR, dispatch);
    });
};

export const updateTrackingId = (data) => async (dispatch, getState) => {
  const config = getConfig(getState());
  const { portal } = config;
  dispatch({ type: CONSTANTS.UPDATE_TENANT_INFO_REQUEST })
  const { trackingId } = data;
  const payload = { name : GOOGLE_ANALYTICS_ID , value : trackingId }
  const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/${GOOGLE_ANALYTICS_ID}`
  await axios.put(url, payload)
    .then((response) => {
      if (response.status === 200) {
        dispatch({ type: CONSTANTS.UPDATE_TENANT_INFO_SUCCESS, payload : true });
      }
    })
    .catch((error) => {
      handleError(error, CONSTANTS.UPDATE_TENANT_INFO_ERROR, dispatch);
    });
};

const handleError = (error, errorAction, dispatch) => {
  const response = error?.response || {};
  const errorData = response.data?.error || {}

  if (errorData.detail?.userErrorMessage) {
    dispatch({ type: errorAction, payload: errorData.detail?.userErrorMessage || '' });
    return;
  }

  if (errorData.detail?.errorCode) {
    const errorCode = errorData.detail?.errorCode;
    dispatch({ type: errorAction, payload: { errorCode } });
    return;
  }

  dispatch({ type: errorAction, payload: '' });
}
